import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dialog, Grid, Typography } from '@mui/material';
import { SlideTransition } from '../Transition/Transition';
import { getVCardString } from '../../utils/vcard';
import QRCodeComponent from '../QRCodeComponent';
import './ECardDialog.scss';
import { useTheme } from '@mui/material/styles';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import MailRoundedIcon from '@mui/icons-material/MailRounded';
import { formatPhoneNumber } from '../../utils/user';

const FullWidthStyle = {
  width: '100%'
};

const FirstGridItemStyle = {
  ...FullWidthStyle,
  padding: 24
};

const SecondGridItemStyle = {
  ...FullWidthStyle,
  padding: '12px 16px'
};

const ThirdGridItemStyle = {
  ...FullWidthStyle,
  padding: '0 24px 16px'
};

const NameTypoStyle = {
  fontSize: '2rem',
  lineHeight: 1.5
};

const IconStyle = {
  verticalAlign: 'middle'
};

const HintTypoStyle = {
  padding: 8,
  borderRadius: 8,
  fontSize: '1.5rem'
};

const ECardDialog = props => {
  const { intl, userDetails, className, ...rest } = props;

  const theme = useTheme();

  const { name, phoneNumber, workEmail } = userDetails || {};

  const vCardString = getVCardString(userDetails);

  return (
    <Fragment>
      <Dialog
        className={`e-card-dialog${className ? ` ${className}` : ''}`}
        fullWidth={true}
        maxWidth="xs"
        {...rest}
        slots={{
          transition: SlideTransition
        }}
      >
        <Grid container sx={{ flexDirection: 'column', alignItems: 'center' }}>
          <Grid style={{ ...FirstGridItemStyle, background: theme.palette.primary.main }}>
            <Grid container spacing={1}>
              <Grid size={12}>
                <Typography color="textPrimary" style={NameTypoStyle}>
                  {name}
                </Typography>
              </Grid>
              <Grid size={12}>
                <Typography color="textPrimary" component="div">
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      alignItems: 'center'
                    }}
                  >
                    <Grid>
                      <PhoneRoundedIcon style={IconStyle} />
                    </Grid>
                    <Grid>{formatPhoneNumber(phoneNumber)}</Grid>
                  </Grid>
                </Typography>
              </Grid>
              <Grid size={12}>
                <Typography color="textPrimary" component="div">
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      alignItems: 'center'
                    }}
                  >
                    <Grid>
                      <MailRoundedIcon style={IconStyle} />
                    </Grid>
                    <Grid>{workEmail}</Grid>
                  </Grid>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid style={SecondGridItemStyle}>
            {vCardString && <QRCodeComponent content={getVCardString(userDetails)} logo={true} />}
          </Grid>
          <Grid style={ThirdGridItemStyle}>
            <Typography
              color="textPrimary"
              align="center"
              style={{ ...HintTypoStyle, background: theme.palette.primary.main }}
            >
              {intl.formatMessage({ id: 'save-my-contact' })}
            </Typography>
          </Grid>
        </Grid>
      </Dialog>
    </Fragment>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails
  }),
  {}
)(ECardDialog);

export default injectIntl(container);
